import axiosInstance from "api"
import { MutationOptions } from "api/api.types"
import { Endpoint } from "api/enpoints.types"
import { AxiosError, AxiosResponse } from "axios"
import { useMutation } from "react-query"

interface IDeleteAccountArgs {
  options?: MutationOptions<null, void>
}

export const useMutationDeleteTeacherAccount = (args?: IDeleteAccountArgs) =>
  useMutation<AxiosResponse<null>, AxiosError, void>(
    async () => axiosInstance.delete(Endpoint.TEACHER_ME),
    args?.options,
  )
